var map = {
	"./AI钢琴回复.png": 131,
	"./AlphaGoTeach.png": 132,
	"./AppCenter_ai_emotion.jpg": 133,
	"./AppCenter_ai_speech.jpg": 134,
	"./AppCenter_ai_teachableMachine.jpg": 135,
	"./CNN 解释器(层计算过程.png": 136,
	"./CNN.png": 137,
	"./Handwritten.png": 138,
	"./IBM聊天机器人（英语，加载慢）.png": 139,
	"./OCR文字识别.png": 140,
	"./Real_time_speech_recognition.png": 141,
	"./Teachable Machine（自定义训练姿态分类器）.png": 142,
	"./Teachable Machine（自定义训练物体分类器）.png": 143,
	"./Teachable Machine（自定义训练语音分类器）.png": 144,
	"./Text-To-Speech.jpg": 145,
	"./ai_duet.jpg": 146,
	"./aihub-logo.png": 78,
	"./art/图像修补.png": 147,
	"./art/抽象画生成真实图片（加载较慢）.png": 148,
	"./background.jpg": 149,
	"./banner/AI入门banner.jpg": 80,
	"./banner/AI文本banner.jpg": 81,
	"./banner/AI艺术banner.jpg": 82,
	"./banner/AI视觉banner.jpg": 83,
	"./banner/AI语音banner.jpg": 84,
	"./beginner_visual_guide.jpg": 150,
	"./body_detection_demo.png": 151,
	"./celebrities_landmarks.png": 152,
	"./celebrities_landmarks_demo.png": 153,
	"./chatbot.jpg": 154,
	"./chinese_text_analyze_demo.png": 155,
	"./chinese_text_analyze_demo_header.png": 156,
	"./completion.jpg": 157,
	"./controlled_brush.jpg": 158,
	"./conversation_transcription.png": 159,
	"./conversation_transcription_demo.png": 160,
	"./couplets.jpg": 161,
	"./create_music.jpg": 162,
	"./custom_speech.png": 163,
	"./custom_speech_demo.png": 164,
	"./demo1.png": 165,
	"./demo2.png": 166,
	"./demo3.png": 167,
	"./demo4.png": 168,
	"./emotion_detect_demo.png": 169,
	"./face-api-demo.jpg": 170,
	"./face_api.png": 171,
	"./face_detection.png": 172,
	"./face_detection_demo.png": 173,
	"./face_expression_demo.png": 174,
	"./face_landmark_demo.png": 175,
	"./face_mesh.png": 176,
	"./face_search_demo.jpeg": 177,
	"./face_verification.png": 178,
	"./face_verification_demo.png": 179,
	"./gesture_recognition_demo.png": 180,
	"./graffiti.jpg": 181,
	"./language_class_demo.png": 182,
	"./language_understand.png": 183,
	"./language_understand_demo.png": 184,
	"./machine_learning.jpg": 185,
	"./neural_network.png": 186,
	"./picture_analyze.png": 187,
	"./picture_analyze_demo.png": 188,
	"./pingyin.jpg": 189,
	"./poem.jpg": 190,
	"./pose_esimation.png": 191,
	"./pose_esimation_demo.png": 192,
	"./preloader.gif": 85,
	"./print&writing_recog.png": 193,
	"./print&writing_recog_demo.png": 194,
	"./real_time.png": 195,
	"./search.jpg": 196,
	"./speaker_identification.png": 197,
	"./speaker_identification_demo.png": 198,
	"./speaker_verification.png": 199,
	"./speaker_verification_demo.png": 200,
	"./speech/在线语音合成).png": 201,
	"./speech/语音合成（文本转语音）).png": 202,
	"./speech/语音听写.png": 203,
	"./speech/语音控制画笔.png": 204,
	"./speech/语音转译（语音转文字).png": 205,
	"./speech_synthesis.png": 206,
	"./speech_transcription.png": 207,
	"./speech_transcription_demo.png": 208,
	"./synthetic.png": 209,
	"./text_analyze.png": 210,
	"./text_analyze_demo.png": 211,
	"./text_understand.png": 212,
	"./text_understand_demo.png": 213,
	"./tone_analyze_demo.png": 214,
	"./translation.jpg": 215,
	"./vision/手写数字识别.png": 216,
	"./word_association.jpg": 217,
	"./与书对话.png": 218,
	"./中文校对.png": 219,
	"./公式识别).png": 220,
	"./关键词提取).png": 221,
	"./创造新乐器声音.png": 222,
	"./动物头像生成).png": 223,
	"./动物头像生成.png": 224,
	"./動物頭像生成.png": 225,
	"./图像修补.png": 226,
	"./图解机器学习.png": 227,
	"./在线围棋.png": 228,
	"./在线语音合成).png": 229,
	"./在线象棋.png": 230,
	"./姿态识别.png": 231,
	"./强化学习模拟.png": 232,
	"./快速涂鸦.png": 233,
	"./快速涂鸦简笔画.png": 234,
	"./快速涂鸦识别.png": 235,
	"./手写数字识别 - 副本.png": 236,
	"./手写数字识别.png": 237,
	"./手写数字识别2.png": 238,
	"./手部识别与追踪.png": 239,
	"./抽象画生成真实图片（加载较慢）.png": 240,
	"./抽象畫生成真實圖片.png": 241,
	"./拍照速算识别).png": 242,
	"./拼写检查（英语）.png": 243,
	"./指尖文字识别.png": 244,
	"./搜索关联性最大的实体（英语等）.png": 245,
	"./操控交响乐队.png": 246,
	"./攻击性语言检测（英语）.png": 247,
	"./教学机.png": 248,
	"./数据分类器(调参过程).png": 249,
	"./文本情感分析).png": 250,
	"./机器翻译).png": 251,
	"./物体识别.png": 252,
	"./生成对抗网络体验.png": 253,
	"./神经网络.png": 254,
	"./简笔画效果多重预测.png": 255,
	"./线稿上色.png": 256,
	"./自动写诗).png": 257,
	"./自动对联).png": 258,
	"./與書對話.png": 259,
	"./英文校对.png": 260,
	"./識別圖片播放背景音.png": 261,
	"./识别图片播放背景音.png": 262,
	"./词法分析).png": 263,
	"./语义搜索支持的单词联想游戏.png": 264,
	"./语音合成（文本转语音）).png": 265,
	"./语音听写.png": 266,
	"./语音控制画笔.png": 267,
	"./语音识别.png": 268,
	"./语音识别（英语，单词）.png": 269,
	"./语音转译（语音转文字).png": 270,
	"./路径规划.png": 271,
	"./键入时自动推荐与补全).png": 272,
	"./随机图像的插值图.png": 273,
	"./面网.png": 274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;